import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectHideSenderImageOption')(function selectShowPreviewTextOption(hideSenderImage, state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = hideSenderImage;
}));
//# sourceMappingURL=selectHideSenderImageOption.js.map